import { getComments } from "@/libs/api.js";
import { uleCdn } from "@/libs/common.js";
import { ImagePreview } from 'vant';

export default {
	name: "itemComment",
	components: {},
	data() {
		return {
			tabs: [
				{
					name: "全部内容",
					total: 100,
				},
				{
					name: "有图",
					total: 0,
				},
			],
			actived: 0,
			commentList: [],
			loading: false,
			finished: false,
			finishedText: "",
			supportEmoji: false,
			query: {
				listingId: this.$route.params.listId,
				pageNum: 1,
				pageSize: 10,
				commentImgFlag: 0, // 0-全部 1-图片
			}
		};
	},
	methods: {
		getComment() {
			let currentVal = `jsonp${30+this.query.pageNum}`;
			getComments(this.query, currentVal).then((res) => {
				this.loading = false;
				this.finished = true;
				if (res.code == "0000") {
					if (res && res.data) {
						if (res.data.list.length > 0) {
							this.commentList =this.commentList.concat(res.data.list);
							console.log(this.commentList, ' commentList')
							let totalPages = Math.ceil(res.data.total / this.query.pageSize);
							console.log("totalPages", totalPages);
							if (this.query.pageNum == totalPages) {
								this.finished = true;
								this.finishedText = "没有更多了";
							} else {
								this.finished = false;
								this.query.pageNum++;
							}
						} else {
							this.finished = true;
							this.finishedText = "没有更多了";
						}
					} else {
						this.finished = true;
					}
				} else {
					this.finished = true;
				}
			});
		},
		tabChange(index) {
			if (this.actived == index) {
				return false;
			}
			this.actived = index;
			this.query.commentImgFlag = index;
			this.query.pageNum = 1;
			this.commentList = [];
			this.getComment();
		},
		getCommentTotal(type) {
			let query = {
				listingId: this.$route.params.listId,
				pageNum: 1,
				pageSize: 10,
				commentImgFlag: type,
			};
			let currentVal = `jsonp${type + 12}`;
			return getComments(query, currentVal).then((res) => {
				if (res.code == "0000") {
					if (res && res.data) {
						return res.data.total;
					} else {
						return 0;
					}
				} else {
					return 0;
				}
			});
		},
		// emoji表情替换
		emojiFunc: function(text){
			if (this.supportEmoji) {
				// 浏览器支持emoji 不替换
				return text;
			} else {
				return text.replace(Emoji.reg, function(code) {
					return '<img width="15" class="emoji" style="vertical-align:middle;display: inline-block;" src="' + Emoji.emojiPath + Emoji._escapeToUtf32(code) + '.png">';
				});
			}
		},
		imgPreview: (images, index)=> {
			console.log(images, 'images')
			ImagePreview({
				images: images,
				startPosition: index,
				maxZoom:1
			})
		},
	},
	async mounted() {
		this.$nextTick( () => {
			// 检查浏览器是否支持emoji符号
			this.supportEmoji = function() {
				if (navigator.userAgent.match(/Mac\s+OS/i) && !navigator.userAgent.match(/(Chrome|Firefox)/i)) {
					return true;
				}
				return false;
			}()
			if (!this.supportEmoji) {
				let script = document.createElement("script"); //创建script标签节点
				script.setAttribute("type", "text/javascript"); //设置script类型
				script.setAttribute("src", `//i1.${uleCdn()}/ule/www/emoji/emoji.js`); //设置js地址
				document.body.appendChild(script); //将js追加为body的子标签
			}
		})
		this.tabs[0].total = await this.getCommentTotal(0);
		this.tabs[1].total = await this.getCommentTotal(1);
		this.getComment();
	},
};
